<template>
    <div>                       
      <v-row v-for="(item, questionIndex) in Questions" :key="questionIndex" >        
        <v-col col="12" >                    
              <v-img v-bind:src="questionUserProfile.avatar" class="user-avatar" alt="User Profile Image"></v-img>
              <div class="user-display-name">{{questionUserProfile.displayName}}</div>
              <div class="post-question-datetime">{{createdDate(item.createdAt)}}</div>                      
              <div class="question">
                  {{item.question}}                          
              </div>                  
              <div class="answers-obj">
                <!-- FIXME: for the load profile from user table -->
                  <v-row v-for="(res, answerIndex) in item.answers" :key="answerIndex">
                      <v-col col="12" >                                
                          <v-img v-bind:src="res.profilePicture" class="user-avatar" alt="User Profile Image"></v-img>
                          <div class="user-display-name">{{res.profileName}}</div>
                          <div class="post-question-datetime">{{createdDate(res.createdAt)}}</div>
                          <div class="answers">{{res.comment}}</div>                                                                                                                                                                    
                      </v-col>                               
                  </v-row>                                             
              </div>
              <!-- This is Question reply box -->
              <div class="reply-box noActive" :id="'reply_question_'+ questionIndex"   style="text-align:right;">
                <form>
                    <v-container fluid>
                        <v-textarea
                        counter
                        outlined                                            
                        placeholder="reply here..."                                            
                        v-model="comment"
                        style="margin-bottom:0px !important;"
                        ></v-textarea>                                        
                    </v-container>
                    <v-btn class="ma-2" text tile color="info" @click="submitClick(questionIndex)">
                        <v-icon left>mdi-check</v-icon>Submit
                    </v-btn> 
                    <v-btn  class="ma-2" text tile color="error" @click="cancelClick(questionIndex)">
                        <v-icon left>mdi-cancel</v-icon>Cancel
                    </v-btn>                                    
                </form>
              </div>                                                    
              <div v-if="item.userID !== activeUser.id || item.answers.length > 0" class="reply-btn" :id="'reply_question_btn_' + questionIndex">
                  <v-btn class="ma-2" text tile color="secondary" @click="replyClick(questionIndex)">
                      <v-icon left>mdi-message</v-icon>Reply
                  </v-btn>
              </div>                                                                           
        </v-col>
        <hr width="98%" style="margin-left:auto;margin-right:auto;" v-show="questionIndex < Questions.length - 1"/>       
      </v-row>             
    </div>
</template>
<style scoped>
    .user-avatar {
        width:50px;
        height:50px;
        border-radius:50%;
        float:left;
    }
    .user-display-name {
        float: left;
        margin-top:10px;
        margin-left:15px;
        font-weight:500;
    }
    .post-question-datetime {
        float: left;
        margin-top:10px;
        margin-left:15px;
        font-weight:300;
    }
    .question {
        margin-left:65px;
        clear:both;
        font-size:20px;
        font-weight:600;
    }
    .question-border-bottom {        
        border-bottom:1px solid #eee;
        padding: 10px;
    }
    @media only screen and (max-width: 600px) {
      .answers-obj {
        margin-top: 15px;
        margin-left: 20px;
        font-size:15px;        
      }
      .reply-btn {
        margin-top:10px;
        margin-left:20px;
        clear:both;
          font-size:11px;        
      }
      .reply-box {
          margin-left:20px;
          animation-name: moveDown;
          animation-duration: 4s;
      }
      .answers {
        margin-left: 65px;
        font-size:18px;
        clear:both;
    }  
    }
    @media only screen and (min-width: 601px) {
      .answers-obj {
        margin-top: 15px;
        margin-left: 100px;
        font-size:15px;        
      }
      .reply-btn {
        margin-top:10px;
        margin-left:85px;
        clear:both;
        font-size:11px;        
      }
      .reply-box {
        margin-left:85px;
        animation-name: moveDown;
        animation-duration: 4s;
      }
      .answers {
        margin-left: 65px;
        font-size:18px;
        clear:both;
    }  
    }          
    .noActive {
        display: none;
    }
    .active {
        display: block;
    }
    @keyframes moveDown {
      0%   {top:0px; bottom:0px;}      
      50%  {top:100px; bottom:100px;}      
      100% {top:0px; top:0px;}      
    }
</style>
<script>
import { mapState } from 'vuex';
import config from '@/config';
import moment from 'moment';
import userAPIs from '../../User/userAPIs';
import pairingAPIs from '../../Pairing/pairingAPIs';
export default {
  name: 'QandA',
  props: ['Questions', 'campaignID', 'influencerID', 'TriggerEmail', 'pairedID'],
  data() {
    return {
      questionUserProfile: {
        usrId: '',
        displayName: '',
        avatar: ''
      },
      answerUserProfile: {
        usrId: '',
        displayName: '',
        avatar: ''
      },
      comment: ''
    }
  },
  computed: {
    ...mapState(['userInfo', 'user']),
    activeUser() {
      return {
        displayName: this.user.firstName + ' ' + this.user.lastName,
        avatar: this.user.profilePicture ? this.user.profilePicture : '/static/img/avatar/user.png',
        email: this.user.email,
        createdAt: moment(this.user.createdAt).format('MMM D, YYYY'),
        role: config['userRolesDetails'][this.user.role]['display'],
        id: this.user.id
      };
    }
  },
  mounted() {
    this.loadQuestions()
  },
  methods: {
    createdDate(val) {
      return moment(val).format('MMM DD, yyyy hh:mm')
    },
    async loadQuestions() {
      let allQuestions = await pairingAPIs.getQuestions(this.campaignID, this.influencerID)
      let questionArray = [];
      // console.log('all question', allQuestions)
      for (let questionObj of allQuestions) {
        // console.log('Question', questionObj.question)
        questionArray.push(questionObj)
      }
      this.Questions = questionArray;
      if (this.Questions.length > 0) {
        this.getUserProfile(this.Questions[0].userID)
      }
    },
    async getUserProfile(userID) {
      let userProfile = await userAPIs.getUser(userID)
      this.questionUserProfile.userId = userProfile.id
      this.questionUserProfile.avatar = userProfile.profilePicture ? userProfile.profilePicture : '/static/img/avatar/user.png'
      this.questionUserProfile.displayName = `${userProfile.firstName} ${userProfile.lastName}`
    },
    async getAnswerUserProfile(userID) {
      /**
       * FIXME:
       * Load answers user profile from the user table
       */
      let userProfile = await userAPIs.getUser(userID)
      this.answerUserProfile.userId = userProfile.id
      this.answerUserProfile.avatar = userProfile.profilePicture ? userProfile.profilePicture : '/static/img/avatar/user.png'
      this.answerUserProfile.displayName = `${userProfile.firstName} ${userProfile.lastName}`

      return { avatar: this.answerUserProfile.avatar, displayName: this.answerUserProfile.displayName }
    },
    replyClick(index) {
      let replyDiv = document.getElementById('reply_question_' + index)
      let replyBtn = document.getElementById('reply_question_btn_' + index)
      replyDiv.classList.add('active')
      replyBtn.classList.add('noActive')
    },
    cancelClick(index) {
      let replyDiv = document.getElementById('reply_question_' + index)
      let replyBtn = document.getElementById('reply_question_btn_' + index)
      replyDiv.classList.remove('active')
      replyBtn.classList.remove('noActive')
      this.comment = ''
    },
    async submitClick(index) {
      // console.log('Question', this.Questions)
      let answersArray = []
      let commentObj = {
        id: this.user.id,
        profilePicture: this.activeUser.avatar,
        profileName: this.activeUser.displayName,
        comment: this.comment,
        createdAt: Date.now()
      }
      // Check the answers obj has data or not in first time?
      if (this.Questions[index].answers.length > 0) {
        // Loop through to merge answers
        for (let i = 0; i < this.Questions[index].answers.length; i++) {
          answersArray = [...answersArray, this.Questions[index].answers[i]]
        }
        answersArray = [...answersArray, commentObj]
      } else answersArray.push(commentObj)

      let params = {
        id: this.Questions[index].id, // Question ID
        answers: answersArray
      }
      // console.log('Answers Obj', params)
      await pairingAPIs.putComment(params)
      this.loadQuestions()
      if (this.TriggerEmail) {
        this.triggerEmail(this.Questions[index].question, this.comment)
      }
      this.cancelClick(index)
    },
    async triggerEmail(question, reply) {
      // Check user role to trigger email
      if (this.activeUser.role.toLowerCase() === 'influencer') {
        let params = {
          campaignID: this.campaignID,
          influencer: this.activeUser.displayName,
          url: `${window.location.protocol}//${window.location.host}/influencers/pairing/${this.pairedID}`,
          type: 'reply',
          question,
          reply
        }
        await pairingAPIs.triggerEmailToCO(params)
      } else {
        let params = {
          influencerId: this.influencerID,
          campaignID: this.campaignID,
          influencer: this.activeUser.displayName,
          url: `${window.location.protocol}//${window.location.host}/campaigns/${this.campaignID}/invitation`,
          type: 'reply',
          question,
          reply
        }
        await pairingAPIs.triggerEmailToInfluencer(params)
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// QandA.vue?353cf2b0